<template>
  <div class="rankAndAbility">
    <div class="box-left">
      <div class="box-title">细分领域服务商排行</div>
      <div class="rankItem" style="font-weight:bold;font-size:18px;">
        <div class="rankItem-rank" style="color:#000">排名</div>
        <div class="rankItem-sort">服务分类</div>
        <div class="rankItem-num">服务商数量</div>
      </div>
      <div
        class="rankItem"
        v-for="(item, index) in rankList"
        :key="index"
        v-show="index < 10"
      >
        <div class="rankItem-rank">TOP{{ index + 1 }}</div>
        <div class="rankItem-sort" style="font-size:16px;">
          {{ item.title }}
        </div>
        <div class="rankItem-num">
          <el-progress
            v-if="index == 0"
            :percentage="(item.count / sum).toFixed(2) * 100"
            color="#FF4D4D"
            :show-text="false"
            class="rankItem-progress"
          ></el-progress>
          <el-progress
            v-else-if="index == 1"
            :percentage="(item.count / sum).toFixed(2) * 100"
            color="#ED9943"
            :show-text="false"
            class="rankItem-progress"
          ></el-progress>
          <el-progress
            v-else-if="index == 2"
            :percentage="(item.count / sum).toFixed(2) * 100"
            color="#1FCBAB"
            :show-text="false"
            class="rankItem-progress"
          ></el-progress>
          <el-progress
            v-else
            :percentage="(item.count / sum).toFixed(2) * 100"
            color="#3981E5"
            :show-text="false"
            class="rankItem-progress"
          ></el-progress>
          <div class="num">{{ item.count }}</div>
        </div>
      </div>
    </div>
    <div class="box-right">
      <div class="box-title">服务商服务能力</div>
      <div id="chartAbility" class="ability"></div>
    </div>
  </div>
</template>

<script>
import { programStatic, capabilityStatic } from "../../utils/interface"

export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      rankList: [
        // { title: '软件开发与设计', count: 290 }
      ],
      sum: 0, // 总数
      abilityList: [
        { name: "工厂设计", value: "2753" },
        { name: "产品研发", value: "2753" },
        { name: "工艺设计", value: "2753" },
        { name: "工厂设计", value: "1753" },
        { name: "工厂设计", value: "2753" },
        { name: "工厂设计", value: "2753" },
        { name: "工厂设计", value: "2753" },
        { name: "工厂设计", value: "2753" },
        { name: "工厂设计", value: "2753" },
      ],
    }
  },
  watch: {},
  computed: {},
  created() {
    this.programStatic() // 细分领域服务商分类
  },
  mounted() {
    this.capabilityStatic()
  },
  methods: {
    // 细分领域服务商分类
    programStatic() {
      programStatic({
        status: 1,
      }).then((res) => {
        this.sum = 0
        if (res && res.length > 0) {
          res.map((item) => {
            this.sum += item.count
          })
          if (res.length > 10) {
            this.rankList = res.slice(0, 10)
          } else {
            this.rankList = res
          }
        } else {
          this.rankList = []
        }
      })
    },
    // 服务能力统计
    capabilityStatic() {
      capabilityStatic({
        status: 1,
      }).then((res) => {
        if (res && res.length > 0) {
          if (res.length > 10) {
            this.abilityList = res.slice(0, 10)
          } else {
            this.abilityList = res
          }
          this.$nextTick(() => {
            this.initChart()
          })
        } else {
          this.abilityList = []
        }
      })
    },
    initChart() {
      let chartDom = document.getElementById("chartAbility")
      let myChart = this.$echarts.init(chartDom)
      let xArr = []
      let yArr = []
      this.abilityList.forEach((el) => {
        el.title =
          el.title.slice(0, 2) + "\n" + el.title.slice(2, el.title.length)
        xArr.push(el.title)
        yArr.push(el.count * 1)
      })
      let option
      option = {
        grid: {
          left: 0,
          right: 0,
          top: "10%",
          bottom: "10%",
        },
        xAxis: [
          {
            type: "category",
            data: xArr,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontSize: 14,
              fontWeight: 600,
              textStyle: {
                color: "#000",
              },
            },
          },
          {
            type: "category",
            data: yArr,
            position: "top",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontSize: 14,
              fontWeight: 600,
              textStyle: {
                color: function(value, index) {
                  // console.log('index', index)
                  if (index == 0) {
                    return "#FF4D4C"
                  } else if (index == 1) {
                    return "#FA9D4B"
                  } else if (index == 2) {
                    return "#35C3A4"
                  } else {
                    return "#3476E2"
                  }
                },
              },
            },
          },
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            show: false,
          },
        },
        series: [
          {
            data: yArr,
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                // barBorderRadius: 10,
                color: function(params) {
                  var color
                  if (params.dataIndex == 0) {
                    color = {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,

                          color: "#FF484A", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "#FFDEDD", // 100% 处的颜色
                        },
                      ],
                    }
                  } else if (params.dataIndex == 1) {
                    color = {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,

                          color: "#EF9E4C", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "#FCE7D2", // 100% 处的颜色
                        },
                      ],
                    }
                  } else if (params.dataIndex == 2) {
                    color = {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,

                          color: "#2CCCAC", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "#CFFBEE", // 100% 处的颜色
                        },
                      ],
                    }
                  } else {
                    color = {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: "#5286E4", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "#DEEDFE", // 100% 处的颜色
                        },
                      ],
                    }
                  }
                  return color
                },
              },
            },
          },
        ],
      }

      option && myChart.setOption(option)
    },
  },
}
</script>
<style lang="less" scoped>
.rankAndAbility {
  width: 1300px;
  height: 500px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: -40px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-content: center;

  .box-left,
  .box-right {
    width: 630px;
    height: 480px;
    border-radius: 8px;
    // box-shadow: 0 0 8px #99999947;
    box-sizing: border-box;
    padding: 0 25px;

    .box-title {
      font-size: 22px;
      font-weight: 600;
      text-align: center;
      margin: 12px 0;
    }
  }

  .box-left {
    .rankItem {
      width: 100%;
      height: 37px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #eceefd;
      font-size: 15px;
      font-weight: 600;

      &:nth-of-type(3) {
        .rankItem-rank {
          color: #ff4d4d;
        }
      }

      &:nth-of-type(4) {
        .rankItem-rank {
          color: #ed9943;
        }
      }

      &:nth-of-type(5) {
        .rankItem-rank {
          color: #1fcbab;
        }
      }

      &:last-child {
        border: none;
      }

      .rankItem-rank {
        width: 85px;
        color: #3981e5;
      }

      .rankItem-sort {
        width: 250px;
      }

      .rankItem-num {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .rankItem-progress {
          width: 80%;
        }

        .num {
          flex: 1;
          text-align: center;
        }
      }
    }
  }

  .box-right {
    .ability {
      width: 580px;
      height: 400px;
    }
  }
}

/deep/ .el-progress-bar__outer {
  border-radius: 0;
}

/deep/ .el-progress-bar__inner {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/rankAndAbility.vue